import script from "./mineralType.vue?vue&type=script&setup=true&lang=js"
export * from "./mineralType.vue?vue&type=script&setup=true&lang=js"

import "./mineralType.vue?vue&type=style&index=0&id=594a97ec&lang=scss"

const __exports__ = script;

export default __exports__